var moduleMap = {
	".": () => {
		return Promise.all([__webpack_require__.e(925), __webpack_require__.e(202), __webpack_require__.e(182), __webpack_require__.e(208), __webpack_require__.e(594), __webpack_require__.e(687), __webpack_require__.e(376), __webpack_require__.e(702), __webpack_require__.e(206), __webpack_require__.e(864), __webpack_require__.e(104), __webpack_require__.e(671)]).then(() => (() => ((__webpack_require__(72400)))));
	},
	"./shift-manager": () => {
		return Promise.all([__webpack_require__.e(925), __webpack_require__.e(202), __webpack_require__.e(208), __webpack_require__.e(594), __webpack_require__.e(687), __webpack_require__.e(376), __webpack_require__.e(702), __webpack_require__.e(206), __webpack_require__.e(864), __webpack_require__.e(946)]).then(() => (() => ((__webpack_require__(72946)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});